module.exports = __webpack_public_path__ + "img/haunt_messagebox_menu.006ac873.png";